var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M313.424,279.91c-1.625,0-2.943,1.317-2.943,2.943v50.023c0,100.046,70.621,117.701,70.621,117.701  s70.621-17.655,70.621-117.701v-50.023c0-1.625-1.317-2.943-2.943-2.943H313.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M444.367,287.267v45.609c0,85.093-52.598,106.557-63.262,110.032  c-10.724-3.497-63.267-24.983-63.267-110.032v-45.609L444.367,287.267 M448.781,279.91H313.424c-1.625,0-2.943,1.317-2.943,2.943  v50.023c0,100.046,70.621,117.701,70.621,117.701s70.621-17.655,70.621-117.701v-50.023  C451.723,281.228,450.406,279.91,448.781,279.91L448.781,279.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M389,373.111h-15.053c0,0-12.14,12.14-14.923,38.808c-0.089,0.851,0.254,1.712,0.927,2.239  c2.553,2,9.727,6.622,21.522,6.622s18.97-4.621,21.522-6.622c0.673-0.527,1.016-1.389,0.927-2.239  C401.14,385.251,389,373.111,389,373.111z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M389,370.602h-15.053V355c0-2.458,2.011-4.469,4.469-4.469h6.115c2.458,0,4.469,2.011,4.469,4.469   L389,370.602L389,370.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M390.019,375.62h-17.092c-0.823,0-1.49-0.667-1.49-1.49v-2.038c0-0.823,0.667-1.49,1.49-1.49h17.092   c0.823,0,1.49,0.667,1.49,1.49v2.038C391.509,374.953,390.842,375.62,390.019,375.62z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D35A10"
    },
    d: "M439.178,320.146c-0.445,0-6.99,0.03-13.799,1.201v-3.923c5.746-2.623,11.377-3.979,11.473-4.002  c0.674-0.158,1.093-0.833,0.935-1.508c-0.159-0.674-0.833-1.094-1.507-0.935c-0.379,0.088-5.436,1.303-10.945,3.702  c-0.09-1.504-0.611-2.883-1.459-4.023c4.496-3.48,8.326-5.691,8.397-5.732c0.602-0.343,0.812-1.109,0.469-1.711  c-0.345-0.603-1.111-0.812-1.711-0.469c-0.304,0.173-4.321,2.49-8.984,6.134c-1.199-0.808-2.642-1.28-4.193-1.28  c-1.614,0-3.102,0.521-4.328,1.388c1.286-6.456,3.93-9.251,3.966-9.288c0.485-0.49,0.484-1.281-0.005-1.769  c-0.49-0.49-1.284-0.49-1.774,0c-0.15,0.149-2.587,2.665-4.131,8.322c-1.544-5.657-3.981-8.173-4.131-8.322  c-0.486-0.488-1.275-0.488-1.767-0.002c-0.49,0.485-0.495,1.278-0.012,1.771c0.035,0.036,2.679,2.831,3.966,9.288  c-1.227-0.868-2.715-1.388-4.328-1.388c-1.552,0-2.994,0.473-4.193,1.28c-4.664-3.644-8.681-5.961-8.984-6.134  c-0.603-0.343-1.37-0.134-1.711,0.469c-0.343,0.603-0.132,1.368,0.469,1.711c0.071,0.041,3.901,2.249,8.398,5.73  c-0.848,1.14-1.37,2.519-1.46,4.024c-5.51-2.399-10.566-3.614-10.945-3.702c-0.676-0.162-1.349,0.261-1.507,0.935  c-0.158,0.675,0.261,1.35,0.935,1.508c0.096,0.022,5.726,1.378,11.473,4.002v3.923c-6.809-1.172-13.354-1.201-13.799-1.201  c-0.692,0-1.254,0.561-1.254,1.254c0,0.692,0.561,1.254,1.254,1.254c0.108,0,6.965,0.027,13.799,1.24v4.059  c-3.765-0.112-7.964,0.415-11.851,2.361c-0.62,0.31-0.871,1.063-0.561,1.683c0.221,0.44,0.663,0.693,1.123,0.693  c0.189,0,0.38-0.043,0.56-0.132c3.462-1.73,7.279-2.182,10.729-2.065v15.524c0,1.895-0.189,3.799-0.56,5.659l-1.925,9.621  c-0.136,0.68,0.305,1.34,0.984,1.476c0.083,0.017,0.165,0.024,0.247,0.024c0.586,0,1.11-0.412,1.229-1.008l1.925-9.621  c0.404-2.023,0.609-4.092,0.609-6.151V330.68c1.881,0.21,3.573,0.548,4.932,0.889l0.956,12.425c0.119,1.549,0.895,2.887,2.026,3.795  l-4.068,6.102c-2.18,3.27,0.164,7.65,4.094,7.65h6.701c3.93,0,6.274-4.38,4.094-7.65l-4.068-6.102  c1.131-0.908,1.907-2.246,2.026-3.795l0.956-12.425c1.359-0.341,3.051-0.679,4.932-0.889v15.335c0,2.059,0.205,4.128,0.609,6.151  l1.925,9.621c0.119,0.597,0.643,1.008,1.229,1.008c0.081,0,0.164-0.007,0.247-0.024c0.679-0.136,1.12-0.796,0.984-1.476  l-1.925-9.621c-0.371-1.86-0.56-3.763-0.56-5.659v-15.523c3.45-0.117,7.267,0.335,10.729,2.065c0.18,0.089,0.371,0.132,0.56,0.132  c0.461,0,0.903-0.254,1.123-0.693c0.31-0.62,0.059-1.373-0.561-1.683c-3.888-1.944-8.086-2.471-11.851-2.359v-4.06  c6.833-1.213,13.691-1.24,13.799-1.24c0.693,0,1.254-0.562,1.254-1.254C440.432,320.707,439.87,320.146,439.178,320.146z   M422.87,321.829c-1.499,0.325-2.974,0.711-4.366,1.174c-0.025-0.495-0.098-0.973-0.221-1.438c1.392-1.075,2.954-2.049,4.587-2.914  V321.829z M422.87,315.128v0.694c-1.988,0.986-3.944,2.132-5.695,3.43c-0.364-0.496-0.784-0.945-1.265-1.329  c1.877-2.079,3.962-4.005,6.016-5.704C422.514,313.041,422.87,314.041,422.87,315.128z M417.852,310.11  c0.748,0,1.452,0.176,2.091,0.471c-2.167,1.82-4.366,3.892-6.332,6.139c-0.255-0.078-0.509-0.156-0.776-0.205v-0.133  c0-0.571,0.019-1.113,0.04-1.652C413.081,312.151,415.221,310.11,417.852,310.11z M405.308,310.11c2.631,0,4.771,2.042,4.978,4.62  c0.021,0.539,0.04,1.08,0.04,1.652v0.133c-0.268,0.049-0.521,0.126-0.776,0.205c-1.966-2.247-4.166-4.319-6.333-6.139  C403.855,310.286,404.559,310.11,405.308,310.11z M400.29,315.128c0-1.087,0.356-2.088,0.946-2.91  c2.053,1.699,4.138,3.625,6.015,5.705c-0.482,0.385-0.901,0.833-1.266,1.33c-1.751-1.298-3.708-2.444-5.696-3.43L400.29,315.128  L400.29,315.128z M400.29,318.652c1.634,0.864,3.196,1.839,4.587,2.914c-0.124,0.464-0.197,0.942-0.221,1.437  c-1.392-0.463-2.867-0.849-4.366-1.174V318.652z M400.29,328.13v-3.725c1.572,0.356,3.089,0.786,4.481,1.303l0.247,3.213  C403.653,328.603,402.05,328.312,400.29,328.13z M422.87,328.131c-1.76,0.183-3.363,0.474-4.728,0.791l0.247-3.214  c1.391-0.517,2.909-0.947,4.481-1.303V328.131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA033"
    },
    d: "M359.918,354.016h-5.636l-21.534-19.142c-2.352-2.091-3.348-5.315-2.585-8.369l6.005-24.019  c0.531-2.125,3.178-2.858,4.726-1.309l9.745,9.745c0.528,0.528,1.245,0.825,1.993,0.825h7.287v42.269L359.918,354.016  L359.918,354.016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9480"
    },
    d: "M355.879,305.97l-3.458,15.563c-0.627,2.822-0.52,5.757,0.31,8.526l7.187,23.956h5.636l7.187-23.956  c0.831-2.769,0.938-5.704,0.31-8.526l-3.458-15.563c-0.713-3.21-3.561-5.494-6.85-5.494h-0.015  C359.44,300.475,356.592,302.759,355.879,305.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA0E4"
    },
    d: "M363.881,306.111h-2.29c-0.924,0-1.673,0.749-1.673,1.673v46.231h5.636v-46.231  C365.554,306.86,364.805,306.111,363.881,306.111z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "94.316,0 0,0 0,19.977 94.316,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,68.299 0,94.316 39.71,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,161.684 0,187.701 39.71,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,19.977 256,0 161.684,0 161.684,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,187.701 256,161.684 216.29,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "161.684,174.23 161.684,256 256,256 256,236.023  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,94.316 256,68.299 216.29,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,236.023 0,256 94.316,256 94.316,174.23  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,236.023 256,216.059 172.232,161.684 196.98,161.684 256,199.995 256,187.701    216.29,161.684 256,161.684 256,148.21 148.211,148.21 148.211,256 161.684,256 161.684,174.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "0,148.21 0,161.684 39.71,161.684 0,187.701 0,206.602 69.197,161.684 93.945,161.684    0,222.666 0,236.023 94.316,174.23 94.316,256 107.789,256 107.789,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "107.789,0 94.316,0 94.316,81.77 0,19.977 0,41.839 80.842,94.316 56.094,94.316 0,57.904    0,68.299 39.71,94.316 0,94.316 0,107.79 107.789,107.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,107.79 256,94.316 216.29,94.316 256,68.299 256,49.157 186.432,94.316 161.684,94.316    256,33.093 256,19.977 161.684,81.77 161.684,0 148.211,0 148.211,107.79  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,148.21 256,107.79 148.211,107.79 148.211,0 107.789,0 107.789,107.79 0,107.79    0,148.21 107.789,148.21 107.789,256 148.211,256 148.211,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "69.197,161.684 0,206.602 0,222.666 93.945,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "172.232,161.684 256,216.059 256,199.995 196.98,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "80.842,94.316 0,41.839 0,57.904 56.094,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "186.432,94.316 256,49.157 256,33.093 161.684,94.316  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTc);
export default __webpack_public_path__ + "static/media/tc.9e82c772d7f292ca6c9707ef52587e00.svg";
export { ForwardRef as ReactComponent };